import { Outlet, useLocation } from "react-router-dom";
import Nav from './components/Nav/Nav';


const Layout = () => {

  //const isAdmin = window.location.href.find("admin")
  const location = useLocation()
  const isAdmin = location.pathname.indexOf("admin") !== -1;


  return (
    <>
      <header>
        <Nav />
      </header>
      <main className={isAdmin ? 'admin' : ''}>
      <Outlet />
      </main>
    </>
  )
};

export default Layout;